<template>
    <div class="container-fluid ">
        <Heard />

        <div class="bgImg    w-full ">
            <div class=" w-1100  mx-auto ">
                <div class="">
                    <div class="flex pt-80 ">
                        <div class="textTitle">掌心职学</div>
                        <div class="text-[44px] textTitles">，好就业 高薪资 定制化</div>
                    </div>
                    <div class="my-20 text-[20px]  text-[#444444] font-normal">提高企业招聘效率，增长企业面试通过率</div>

                    <div class="free-for-use cursor-pointer mb-94" @click="handBtn">
                        立即体验
                    </div>
                </div>
            </div>
        </div>
        <div class="mb-100">
            <div class="flex justify-center items-center flex-col mt-95 ">
                <div class="textTitle">掌心职学AI面试 VS 普通面试</div>
                <div class="text-[20px]  text-[#444444] font-normal mt-20">提供企业在海量招聘场景中的效率</div>

            </div>
            <div class="mt-47 flex relative justify-center">
                <div class="bgColor-left w-495 h-427  mr-400  textTitles !text-[34px] !text-[#fff] pt-30 pl-[44px]">
                    <div> 掌心职学</div>
                    <div class="text-[20px]  text-[#fff] font-normal mt-15">提供企业在海量招聘场景中的效率</div>
                    <div class="flex  mt-20" v-for="item in lists" :key="item.name">
                        <div class=" ">
                            <i class="el-icon-circle-check text-[22px] mt-12"></i>
                        </div>
                        <div class="text-[20px]  text-[#fff] font-normal ml-12 w-[330px] pt-1  leading-[2]">{{ item.name
                            }}
                        </div>
                    </div>

                </div>
                <div
                    class="bgColor-right w-495 h-427 absolute ml-430 top-60  pl-110 textTitles !text-[34px] !text-[#fff] pt-33">
                    <div>
                        普通面试
                    </div>


                    <div class="flex  mt-10" v-for="item in listTwo" :key="item.name">
                        <div class="">
                            <i class="el-icon-circle-close text-22  mt-15"></i>
                        </div>
                        <div class="text-[20px]  text-[#fff] font-normal ml-12 w-[330px] pt-4 leading-[2]">{{ item.name
                            }} </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="bg-[#F5FDFF] pt-10">
            <div class="flex justify-center items-center flex-col mt-95 mb-65">
                <div class="textTitle">基于深度学习的多模态建模</div>
                <div class="text-[20px]  text-[#444444] font-normal mt-20 w-[760px] text-center leading-[1.5]">基于深度学习的
                    GAN 模型，在文本、语音、图像、表情、生物特征、视觉 识别等方面，实现高效的多模态融合与转换。</div>

            </div>
            <div class="flex justify-center flex-col items-center">
                <img src="../../../assets/tab-2/2-2@2x.png" fit="cover" class="w-[740px] h-[1006px]">

                <div class="free-for-use cursor-pointer mb-94  ml-35" @click="handBtn">
                    立即体验
                </div>
                <!-- <el-button round size="mini" class="!bg-[#2E77FE] !text-[#fff] !mb-89 !mt-60 !ml-40 !w-[135px] !h-[45px]" @click="handBtn">立即体验</el-button> -->
            </div>
        </div>

        <div class="mb-60">
            <div class="flex justify-center items-center flex-col mt-95 mb-65">
                <div class="textTitle">AI面试胜任力模型算法</div>
                <div class="text-[20px]  text-[#444444] font-normal mt-20 w-[760px] text-center leading-[1.5]">
                    1500个职位/全职位胜任力建模，建立了千万级的 各职位关键行为数据库</div>

            </div>
            <div class="flex justify-center flex-col items-center">
                <img src="../../../assets/tab-2/2-1@2x.png" fit="cover" class="w-[713px] h-[873px]">


            </div>
        </div>

        <Footer />
    </div>
</template>
<script>
import Heard from "@/components/Heard.vue";

import Footer from "@/components/Footer.vue";
export default {
    components: {
        Heard,
        Footer
    },
    metaInfo() {
        return {
            meta: [
                { name: 'keywords', content: this.$route.meta.keywords },
                { name: 'description', content: this.$route.meta.description }
            ]
        };
    },
    data() {
        return {
            lists: [
                {
                    name: '提供专业的虚拟职业面试官，24小时随时进行面试;',
                },
                {
                    name: '面试岗位覆全行业超1500个职位;',
                },
                {
                    name: '各岗位专业面试题库超10万专业题;',
                },
                {
                    name: '企业可个性化自行添加面试问题;',
                }
            ],
            listTwo: [
                {
                    name: '消耗大量人力成本和时间成本;',
                },
                {
                    name: '人才评估依赖面试官的经验，高度的主观性;',
                },
                {
                    name: '非标准化，不同的面试官流程和评估难以统一;',
                },
                {
                    name: '题库有限，普通面试常用题难以涵盖数以干记的岗位特征;',
                }
            ],
        }
    },
    methods: {
        handBtn() {
            window.open('http://web.manager.b.hrclass.com.cn/')
        },
    }
}
</script>
<style scoped>
.free-for-use {
    width: 130px;
    height: 44px;
    line-height: 44px;
    background: #2E77FE;
    border-radius: 22px;
    color: #fff;
    text-align: center;
    margin-top: 25px;
}

.bgImg {

    background: url(~@/assets/home/-h-channel_bg_05.jpg) no-repeat center;
    background-size: 100% 100%;
    overflow: hidden;
}

.bgColor-left {
    background: url(~@/assets/tab-2/2-4@.png) no-repeat center;
    background-size: 100% 100%;

}

.bgColor-right {
    background: url(~@/assets/tab-2/2-3@2x.png) no-repeat center;
    background-size: 100% 100%;
    overflow: hidden;
}
</style>